
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-stepcheck"}},[_c('path',{attrs:{"id":"Positive_Icon","data-name":"Positive Icon","d":"M3.243 5.778a1 1 0 01-1.414 0L.292 4.243a1 1 0 011.415-1.415l.829.829L5.9.293a1 1 0 011.413 1.414z","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_23502","data-name":"Group 23502","transform":"translate(-854.814 -279)"}},[_c('g',{attrs:{"id":"Group_15471","data-name":"Group 15471","transform":"translate(854.814 279)"}},[_c('g',{attrs:{"id":"Path_5578","data-name":"Path 5578","fill":"#fff"}},[_c('path',{attrs:{"d":"M12 23.5c-3.072 0-5.96-1.196-8.132-3.368A11.425 11.425 0 01.5 12c0-3.072 1.196-5.96 3.368-8.132A11.425 11.425 0 0112 .5c3.072 0 5.96 1.196 8.132 3.368A11.425 11.425 0 0123.5 12c0 3.072-1.196 5.96-3.368 8.132A11.425 11.425 0 0112 23.5z"}}),_c('path',{attrs:{"d":"M12 1C9.062 1 6.3 2.144 4.222 4.222A10.928 10.928 0 001 12c0 2.938 1.144 5.7 3.222 7.778A10.928 10.928 0 0012 23c2.938 0 5.7-1.144 7.778-3.222A10.928 10.928 0 0023 12c0-2.938-1.144-5.7-3.222-7.778A10.928 10.928 0 0012 1m0-1c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0z","fill":"#22be9f"}})]),_c('g',{attrs:{"id":"Mask_Group_61","data-name":"Mask Group 61","transform":"translate(8.197 9.232)","clip-path":"url(#clip-path-stepcheck)"}},[_c('g',{attrs:{"id":"_Color","data-name":"↳ 🎨Color","transform":"translate(-4.671 -5.232)"}},[_c('rect',{attrs:{"id":"Base","width":"16","height":"16","fill":"#1bbc9c"}})])])])])])
          )
        }
      }
    